import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-gc_04icon",
  "use": "icon-gc_04icon-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-gc_04icon\">\r\n  <path id=\"icon-gc_04icon_gc_04icon\" d=\"M15.985,6.925H12.167l-.575-2.11L7.117,6.925H6.1l-.575-2.11L.858,6.925H.015V9.58h15.97ZM5.3,0H2.678V5.52L5.3,4.335Zm5.878,0H8.557V5.68l2.618-1.345ZM0,10.155V16H16V10.155ZM3.22,13.8H1.655V11.148H3.22Zm3.132,0H4.787V11.148H6.352Zm3.145,0H7.932V11.148H9.5Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol